





























import {
    defineComponent,
    PropType,
    ref,
    computed,
} from "@nuxtjs/composition-api";
import { useUiHelpers } from "@wemade-vsf/composables";
import { SfButton } from "@storefront-ui/vue";

interface DropDownOption {
    label: string;
    value: string;
}

export default defineComponent({
    name: "DropdownSort",
    components: {
        SfButton,
    },
    props: {
        values: {
            type: Array as PropType<Array<DropDownOption>>,
            default: () => [],
        },
        selected: {
            type: String,
            default: "",
        },
    },
    setup(props, { emit }) {
        const isOpen = ref(false);

        const uiHelpers = useUiHelpers();

        const selectedItem = ref(
            props.selected
                ? props.values.find((option) => option.value === props.selected)
                : null
        );

        function openDropdown() {
            isOpen.value = true;
        }

        function closeDropdown() {
            isOpen.value = false;
        }

        const selectedOption = computed(() => {
            return props.values.find(
                (option) => option.value === props.selected
            );
        });

        function toggleDropdown() {
            isOpen.value ? closeDropdown() : openDropdown();
        }

        function selectItem(option: DropDownOption) {
            selectedItem.value = option;
            emit("change", selectedItem.value);
            closeDropdown();
        }

        const handleChangeSorting = (sort: string) => {
            uiHelpers.changeSorting(sort, false);
            emit("handleChangeSorting", sort);
            closeDropdown();
        };

        return {
            isOpen,
            openDropdown,
            closeDropdown,
            toggleDropdown,
            selectedItem,
            selectItem,
            selectedOption,
            handleChangeSorting,
            ...uiHelpers,
        };
    },
});
